import { useQuery } from 'react-query';
import { UseCurrentEntityOptions } from './useCurrentEntity.types';
import { queryCurrentEntity } from './useCurrentEntity.query';
import { Entity } from '../../../types/models/entity/entity.types';

export const CURRENT_ENTITY_QUERY_KEY = 'CURRENT_ENTITY';

export const useCurrentEntity = (options?: UseCurrentEntityOptions) => {
  return useQuery<Entity, Error>(CURRENT_ENTITY_QUERY_KEY, () => queryCurrentEntity(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
